// extracted by mini-css-extract-plugin
module.exports = {"switch":"gdlSwitch_switch_3TPBA"};